import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Stack } from "@mui/material";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { getSessionPreferences } from "../../../redux/features/croSlice";
import { CRO_SESSION_PREFERENCE_TABLE } from "../../../components/datagrid/CRO/CroSessionPreference";
import AddSessionPreference from "./AddSessionPreference";
import DeleteSessionPreference from "./DeleteSessionPreference";
import { useLocation } from "react-router-dom";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import EditSessionPreference from "./UpdateSessionPreference";

const SessionPreferences = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const courseenrollmentId = searchParams.get("courseenrollmentId");
  const studentname = searchParams.get("studentname");
  const course = searchParams.get("course");
  const phone = searchParams.get("phone");

  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { SessionPreferences, loading } = useSelector((state) => state.cro);

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
    subject_enrollment_id: "",
    course_enrollment_id: courseenrollmentId,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(
        savePaginationData({
          ...paginationData,
          openAnchor: false,
        })
      );
      dispatch(getSessionPreferences(data));
    }
  }, [pageNum, gridSize, search]);

  return (
    <GlobalWrapper
      title={"Session Preferences"}
      actions={
        <AddSessionPreference
          dataparams={data}
          courseenrollmentId={courseenrollmentId}
        />
      }
    >
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        spacing={1}
        sx={{ marginBottom: 2 }}
      >
        <Box
          sx={{
            backgroundImage: "linear-gradient(to right,#1E91D6,#141B41)",
            px: "20px",
            py: "10px",
            borderRadius: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "16px",
          }}
        >
          Name : {studentname}
        </Box>
        <Box
          sx={{
            backgroundImage: "linear-gradient(to right,#1E91D6,#141B41)",
            px: "20px",
            py: "10px",
            borderRadius: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "16px",
          }}
        >
          Phone Number : {phone}
        </Box>
        <Box
          sx={{
            backgroundImage: "linear-gradient(to right,#1E91D6,#141B41)",
            px: "20px",
            py: "10px",
            borderRadius: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "16px",
          }}
        >
          Course : {course}
        </Box>
      </Stack>

      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={CRO_SESSION_PREFERENCE_TABLE}
          rows={SessionPreferences.data}
          meta={SessionPreferences?.meta?.totalRecords || 0}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.id} />
              <GlobalAnchorList
                component={
                  <DeleteSessionPreference data={data} id={rowData?.id} />
                }
                label=""
              />
              <GlobalAnchorList
                component={
                  <EditSessionPreference data={data} rowData={rowData} />
                }
                label="Update"
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SessionPreferences;
